module.exports = __webpack_public_path__ + "img/잠실역 카페.fac051f1.png";